import isInViewport from "../../../src/scripts/helpers/is-in-viewport";

export default class ProjectFacts {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.project-facts'), el => {
            new ProjectFacts(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        window.addEventListener('scroll', (e)=> this.onScroll());
        this.onScroll();
    }

    onScroll() {
        let items = Array.from(this.element.querySelectorAll('.project-facts__header:not(.active),.project-facts__item:not(.active)'));
        let current = items.filter(el => isInViewport(el))

        current.forEach(el => {
            el.classList.add('active');
        });
    }
}
